import React, { useState,useRef } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  PageHeader,
  Row,
  Col,
  Card,
  Divider,
  DatePicker,
} from "antd";
import EmployeementContractTemplate from "../../../components/contracts/EmployeementContractTemplate";
import { useReactToPrint } from "react-to-print";
import { dateFormat } from "../../../utils/Constants";

export default function AddEmployeeContract() {
  const { demandform } = Form.useForm();
  const [englishTitle, setEnglishTitle] = useState("English Title");
  const [arabicTitle, setArabicTitle] = useState("Arabic Title");
  const [visaNo, setVisaNo] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [rlno, setRlno] = useState("");
  const [idNo, setIdNo] = useState("");
  const [country, setCountry] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [itemCategory, setItemCategory] = useState("");
  const [itemQuantity, setItemQuantity] = useState("");
  const [itemSalary, setItemSalary] = useState("");
  const [itemRemarks, setItemRemarks] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [conditionItems, setConditionItems] = useState([]);
  const [contractPeriod, setContractPeriod] = useState("");
  const [daysPerWeek, setDaysPerWeek] = useState("");
  const [basicSalary, setBasicSalary] = useState("");
  const [housingAllowance, setHousingAllowance] = useState("");
  const [transportAllowance, setTransportAllowance] = useState("");
  const [quantity, setQuantity] = useState("");
  const onFinish = () => {};
  const onFinishFailed = () => {};
  let printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    // onAfterPrint: () => {
    //   Items.remove(invoiceItemdispatch, []);
    //   setCustomField1("");
    //   setCustomField2("");
    //   setCustomField3("");
    //   setCustomField4("");
    //   setCustomField5("");
    //   setCustomField6("");
    //   invoiceForm.resetFields();
    //   setEnablePrinting(false);
    //   setIsSaved(true);
    // },
  });
  return (
    <>
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ margin: "15px 0px" }}>
          <Col span={12}>
            <Form.Item
              label="Description in English"
              name="Descriptionenglish"
              rules={[
                {
                  required: true,
                  message: "Please enter description in english",
                },
              ]}
            >
              <Input
              name="customField1"
                placeholder="Enter English title"
                onChange={(e) => setEnglishTitle(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="RL"
              name="rlNo"
              rules={[{ required: true, message: "Please enter RL number" }]}
            >
              <Input
                placeholder="RL Number"
                onChange={(e) => setRlno(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Visa Number"
              name="visaNumber"
              rules={[{ required: true, message: "Please enter visa number" }]}
            >
              <Input
                placeholder="Visa Number"
                onChange={(e) => setVisaNo(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Occupation"
              name="occupation"
              rules={[{ required: true, message: "Please select occupation" }]}
            >
              <Select placeholder="Select occupation">
                <Select.Option value="labour">Labour</Select.Option>
                <Select.Option value="technician">Technician</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Country"
              name="country"
              rules={[{ required: true, message: "Please enter country" }]}
            >
              <Input
                placeholder="Enter country"
                onChange={(e) => setCountry(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Contract Period"
              name="contractPeriod"
              rules={[
                { required: true, message: "Please enter contract period" },
              ]}
            >
              <Input
                placeholder="Enter Contract period"
                onChange={(e) => setContractPeriod(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Basic salary"
              name="basicSalary"
              rules={[{ required: true, message: "Please enter basic salary" }]}
            >
              <Input
                placeholder="Enter basic salary"
                onChange={(e) => setBasicSalary(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Housing Allowance"
              name="housingAllowance"
              rules={[
                { required: true, message: "Please enter housing allowance" },
              ]}
            >
              <Input
                placeholder="Enter transport allowance"
                onChange={(e) => setHousingAllowance(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Transportation Allowance"
              name="transportAllowance"
              rules={[
                { required: true, message: "Please enter transport allowance" },
              ]}
            >
              <Input
                placeholder="Enter Transport Allowance"
                onChange={(e) => setTransportAllowance(e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Description in Arabic"
              name="descriptionArabic"
              rules={[
                {
                  required: true,
                  message: "Please enter description in arabic",
                },
              ]}
            >
              <Input
                placeholder="Enter Arabic title"
                onChange={(e) => setArabicTitle(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Issue Date" name="issueDate">
              <DatePicker
              placeholder="DD/MM/YYYY"
              format={dateFormat}
                onChange={(date, dateString) => {
                  setIssueDate(dateString);
                }}
              />
              {/* <Input type="date"  onChange={(e)=> setIssueDate(e.target.value)}/> */}
            </Form.Item>
            <Form.Item
              label="ID Number"
              name="idNumber"
              rules={[{ required: true, message: "Please enter ID number" }]}
            >
              <Input
                placeholder="ID Number"
                onChange={(e) => setIdNo(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Company Name"
              name="companyName"
              rules={[{ required: true, message: "Please enter Company Name" }]}
            >
              <Input
                placeholder="Company Name"
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Working Days per week"
              name="daysPerWeek"
              rules={[{ required: true, message: "Please enter working days" }]}
            >
              <Input
                placeholder="Enter Contract period"
                onChange={(e) => setDaysPerWeek(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Daily hours"
              name="dailyHours"
              rules={[{ required: true, message: "Please enter daily hours" }]}
            >
              <Input
                placeholder="Enter Daily hours"
                onChange={(e) => setDaysPerWeek(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[{ required: true, message: "Please enter quantity" }]}
            >
              <Input
                placeholder="Enter Daily hours"
                onChange={(e) => setQuantity(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Address" name="address">
              <Input.TextArea
                rows={2}
                placeholder="Enter Address"
                onChange={(e) => setCompanyAddress(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Button onClick={handlePrint} type="primary">
              Print Invoice
            </Button>
          <Col span={20} offset={2}>
            <EmployeementContractTemplate
            ref={printRef}
              englishTitle={englishTitle}
              arabicTitle={arabicTitle}
              issueDate={issueDate}
              visaNo={visaNo}
              idNo={idNo}
              rlno={rlno}
              companyName={companyName}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
}
